import styled from 'styled-components';

import { errorColor } from '~theme';

const Textarea = ({
  value,
  required,
  placeholder,
  rows,
  error,
  id,
  onChange,
  maxLength,
}) => (
  <StyledTextarea
    required={required}
    id={id}
    className="form-control"
    maxLength={maxLength}
    placeholder={placeholder}
    rows={rows || 5}
    value={value}
    error={error}
    onChange={e => onChange(e.target.value)}
  />
);

const StyledTextarea = styled.textarea`
  border-color: ${props => (props.error ? errorColor : '')};
  margin-bottom: 16px;
  font-size: 16px;
  width: 100%;
`;

export default Textarea;
